/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RiseSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.RiseSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'RiseSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RiseRequestCompletion: BridgeCommands.Command<
    Types.Nvapp.Rise.RiseRequestCompletionParameters,
    Types.Nvapp.Rise.RiseRequestCompletionReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'RiseRequestCompletion',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RiseRegister: BridgeCommands.Command<
    Types.Nvapp.Rise.RiseRegisterParameters,
    Types.Nvapp.Rise.RiseRegisterReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'RiseRegister',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RiseGameNotification: BridgeCommands.Command<
    Types.Nvapp.Rise.RiseGameNotificationParameters,
    Types.Nvapp.Rise.RiseGameNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'RiseGameNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RiseUpdatesNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.RiseUpdatesNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'RiseUpdatesNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveCSV: BridgeCommands.Command<
    Types.Nvapp.Rise.SaveCSVParameters,
    Types.Nvapp.Rise.SaveCSVReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'SaveCSV',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqVoiceQuerySupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.VqVoiceQuerySupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqVoiceQuerySupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqResisterVoiceQuery: BridgeCommands.Command<
    Types.Nvapp.Rise.VqResisterVoiceQueryParameters,
    Types.Nvapp.Rise.VqResisterVoiceQueryReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqResisterVoiceQuery',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqVoiceQueryResultNotfication: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.VqVoiceQueryResultNotficationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqVoiceQueryResultNotfication',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqMicDeviceChangedNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.VqMicDeviceChangedNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqMicDeviceChangedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqSetVoiceQuery: BridgeCommands.Command<
    Types.Nvapp.Rise.VqSetVoiceQueryParameters,
    Types.Nvapp.Rise.VqSetVoiceQueryReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqSetVoiceQuery',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqSetVoicePlayback: BridgeCommands.Command<
    Types.Nvapp.Rise.VqSetVoicePlaybackParameters,
    Types.Nvapp.Rise.VqSetVoicePlaybackReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqSetVoicePlayback',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqEnumMicDevices: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.VqEnumMicDevicesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqEnumMicDevices',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqEnumLanguages: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.VqEnumLanguagesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqEnumLanguages',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqEnumVoiceCharacters: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.VqEnumVoiceCharactersReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqEnumVoiceCharacters',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqPrepareMic: BridgeCommands.Command<
    Types.Nvapp.Rise.VqPrepareMicParameters,
    Types.Nvapp.Rise.VqPrepareMicReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqPrepareMic',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const VqTeardownMic: BridgeCommands.Command<
    Types.Nvapp.Rise.VqTeardownMicParameters,
    Types.Nvapp.Rise.VqTeardownMicReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'VqTeardownMic',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GameAssistSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.GameAssistSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'GameAssistSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GameAssistCreateSession: BridgeCommands.Command<
    Types.Nvapp.Rise.GameAssistCreateSessionParameters,
    Types.Nvapp.Rise.GameAssistCreateSessionReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'GameAssistCreateSession',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GameAssistQueryResponseNotfication: BridgeCommands.Command<
    {},
    Types.Nvapp.Rise.GameAssistQueryResponseNotficationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'GameAssistQueryResponseNotfication',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GameAssistSubmitQuery: BridgeCommands.Command<
    Types.Nvapp.Rise.GameAssistSubmitQueryParameters,
    Types.Nvapp.Rise.GameAssistSubmitQueryReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'GameAssistSubmitQuery',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnsureNvAppReadyForGAssist: BridgeCommands.Command<
    Types.Nvapp.Rise.EnsureNvAppReadyForGAssistParameters,
    Types.Nvapp.Rise.EnsureNvAppReadyForGAssistReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Rise',
    method: 'EnsureNvAppReadyForGAssist',
    persistent: false
};

export const Rise = {
RiseSupported,
RiseRequestCompletion,
RiseRegister,
RiseGameNotification,
RiseUpdatesNotifications,
SaveCSV,
VqVoiceQuerySupported,
VqResisterVoiceQuery,
VqVoiceQueryResultNotfication,
VqMicDeviceChangedNotification,
VqSetVoiceQuery,
VqSetVoicePlayback,
VqEnumMicDevices,
VqEnumLanguages,
VqEnumVoiceCharacters,
VqPrepareMic,
VqTeardownMic,
GameAssistSupported,
GameAssistCreateSession,
GameAssistQueryResponseNotfication,
GameAssistSubmitQuery,
EnsureNvAppReadyForGAssist
};
